import Vue from 'vue'
import App from './App.vue'
import router from './router'
import uiwu from './uiwu'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import uiwuHead from '@/components/uiwuHead/uiwuHead.vue'
Vue.component('uiwuHead', uiwuHead)
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.uiwu = uiwu

router.beforeEach((to,from,next)=>{
  /*********动态修改keywords和description*************/
  if(Object.keys(to.meta).length>0 && to.matched.length>0){
    let this_meta=to.matched[to.matched.length-1].meta
   
    if(this_meta.title)document.title=this_meta.title
    let head = document.getElementsByTagName('head');
    let meta_keyword=document.createElement('meta');
    if(document.querySelector('meta[name="keywords"]')){
      document.querySelector('meta[name="keywords"]').setAttribute('content',this_meta.content.keywords)
    }else{
      meta_keyword.setAttribute('name','keywords')
      meta_keyword.setAttribute('content',this_meta.content.keywords)
      head[0].appendChild(meta_keyword)
    }
    let meta_description=document.createElement('meta');
    if(document.querySelector('meta[name="description"]')){
      document.querySelector('meta[name="description"]').setAttribute('content',this_meta.content.description)
    }else{
      meta_description.setAttribute('name','description')
      meta_description.setAttribute('content',this_meta.content.description)
      head[0].appendChild(meta_description)
    }
  }
  /**********************************************/
  next()
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
